import { Tooltip as BaseTooltip, IconButton, TooltipProps as BaseTooltipProps, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import React, { FC, useState } from 'react';
import { rgba } from 'polished';
import { Info } from 'components/Icons/Icons';

interface TooltipProps {
  aria: string;
  label: string;
  maxTooltipWidth?: string;
  placement?: BaseTooltipProps['placement'];
  hasArrow?: boolean;
}

const StyledTooltip = styled(BaseTooltip)<{ maxTooltipWidth?: string }>`
  max-width: ${(props): string => (props.maxTooltipWidth ? props.maxTooltipWidth : '226px')};
`;

const StyledIconButton = styled(IconButton)`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  padding: 0;
  min-width: auto;
  position: relative;
  z-index: 99;

  svg {
    width: 14px;
    height: 14px;
  }
`;

const StyledIconButtonTooltip = styled(IconButton)`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  z-index: -1;
  max-height: 100%;
  min-width: 0;

  svg {
    width: 14px;
    height: 14px;
  }
`;

const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  cursor: pointer;
`;

const Tooltip: FC<TooltipProps> = ({ aria, label, maxTooltipWidth, placement, hasArrow }) => {
  const { colors } = useTheme();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onTooltipTrigger = (): void => setIsOpen(!isOpen);
  const onMouseEnter = (): void => setIsOpen(true);
  const onMouseLeave = (): void => setIsOpen(false);

  return (
    <Wrapper>
      <StyledIconButton
        icon={<Info color={colors.secondary[400]} />}
        aria-label="info button"
        onTouchStart={onTooltipTrigger}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        bg="white"
        color={isOpen ? colors.primary[500] : rgba(colors.secondary[800], 0.2)}
        sx={{
          '&:hover': {
            bg: 'transparent',
          },
          '&:hover svg': {
            color: `${colors.primary[500]} !important`,
          },
        }}
      />
      <StyledTooltip
        bg="other.tooltipBg"
        aria-label={aria}
        label={label}
        maxTooltipWidth={maxTooltipWidth}
        isOpen={isOpen}
        placement={placement}
        hasArrow={hasArrow}
      >
        <StyledIconButtonTooltip aria-label="info tip" icon={<Info color={colors.secondary[400]} />} />
      </StyledTooltip>
    </Wrapper>
  );
};

export default Tooltip;
